// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'

import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import store from "@/store/store";


// import {sync} from "vuex-router-sync";

// todo
// cssVars()
import LightTimeline from "vue-light-timeline";
Vue.use(LightTimeline);
Vue.use(BootstrapVue);

import {videoPlayer} from 'vue-videojs7'

Vue.use(videoPlayer, /* {
  options: global default videojs options,
  events: global videojs videojs events
} */)


// import IdleVue from 'idle-vue'
// const eventsHub = new Vue();
//
// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   idleTime: 10000,
//   events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
// })

// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   idleTime: 5000,
//   events: ['mousemove', 'keydown', 'mousedown', 'touchstart'],
//   keepTracking: true
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  },

})
